var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { "col-12": _vm.isCheckout } }, [
    _c(
      "form",
      {
        ref: "form",
        staticClass: "mb-3 login-pwd-reset guest-login-form",
        attrs: { method: "post" }
      },
      [
        _c(
          "div",
          { staticClass: "input-unit", attrs: { "data-validate": "mail" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              attrs: {
                type: "email",
                name: "email",
                autocomplete: "email",
                id: _vm._uid,
                "data-autofocus": ""
              },
              domProps: { value: _vm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            !_vm.isCheckout
              ? _c("label", { attrs: { for: _vm._uid } }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.loginEmail")) + "*"
                  )
                ])
              : _c("label", { attrs: { for: "_uid" } }, [
                  _vm._v("Neue E-Mail Adresse")
                ])
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "error-msg" }, [
          _vm._v(
            _vm._s(_vm.$translate("Ceres::Template.loginEnterConfirmEmail"))
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-right" }, [
          !_vm.isCheckout
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-medium btn-appearance",
                  attrs: { disabled: _vm.isDisabled },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.validate($event)
                    }
                  }
                },
                [
                  _c("icon", {
                    attrs: { icon: "arrow-right", loading: _vm.isDisabled }
                  }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$translate("Ceres::Template.loginNext")) +
                      "\n            "
                  )
                ],
                1
              )
            : _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-medium btn-appearance",
                  attrs: { disabled: _vm.isDisabled },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.validate($event)
                    }
                  }
                },
                [
                  _c("icon", {
                    attrs: { icon: "arrow-right", loading: _vm.isDisabled }
                  }),
                  _vm._v("\n                Ändern\n            ")
                ],
                1
              )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }